import classnames from 'classnames'
import { Checkmark } from 'components/lib/icons'
import LoaderBalls from 'components/LoaderBalls'
import DateTimeManager from 'modules/dateTime'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Message } from 'types/message'
import { delay } from 'utils'

interface MessageFooterProps {
  message: Message,
  isLastGroup: boolean,
  isLastMessage: boolean,
  delivered: any,
  generated?: any,
  messageTimedOut: boolean,
  deliveryFailed: boolean,
  resolveMessageHeight: () => void
}

const MessageFooter = ({
  message,
  isLastGroup,
  isLastMessage,
  delivered,
  generated,
  messageTimedOut,
  deliveryFailed,
  resolveMessageHeight
}: MessageFooterProps) => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if(messageTimedOut || delivered) {
      delay(() => setIsLoading(false), 500)
    }

    if(!delivered && !isLoading) {
      setIsLoading(true)
    }

    return () => setIsLoading(false)
  }, [delivered, messageTimedOut, isLoading])

  useLayoutEffect(() => {
    resolveMessageHeight()
  }, [resolveMessageHeight, delivered, isLoading, isLastGroup, isLastMessage, deliveryFailed])

  if(!delivered || isLoading) {
    return (
      <li
        key={`${generated}-message-status`}
        className={classnames("drift-widget-message drift-widget-message--meta-date drift-no-op", {
          "drift-widget-message-failed-status": deliveryFailed
        })}>
        <span
          aria-live={deliveryFailed ? 'polite' : 'off'}
          className="drift-widget-message--meta-status"
        >
          {!isLoading && deliveryFailed
            ? t('status.sendMessageFailed')
            : <LoaderBalls size="small" className="drift-widget-message--meta-status__sending" />
          }
        </span>
      </li>
    )
  }

  if(!isLastGroup && !delivered) {
    return (
      <li key={`${generated}-message-status`} className="drift-widget-message drift-widget-message--meta-date drift-no-op" />
    )
  }

  if(isLastMessage && isLastGroup) {
    return (
      <li key={`${message.createdAt}-message-status`} className="drift-widget-message--meta-date drift-widget-message">
        <div className="drift-widget-message--meta-status">
          <Checkmark className="drift-widget-message-sent" height={10} width={12}/>
          <span className="drift-widget-message--meta-date-stamp">{ DateTimeManager.unixFormatDateTime(delivered, t('dt.format.time.short')) }</span>
        </div>
      </li>
    )
  }

  return null
}

export default MessageFooter
